import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=a3ae6ae8&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"
import style0 from "./classify.vue?vue&type=style&index=0&id=a3ae6ae8&prod&lang=scss&scoped=true"
import style1 from "./classify.vue?vue&type=style&index=1&id=a3ae6ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ae6ae8",
  null
  
)

export default component.exports